import { Options } from '@sheerid/jslib';
import { messagesSV } from './lib/intl/sv';
import { messagesEN } from './lib/intl/en-US';
import { RecursivePartial } from './lib/types/types';

export const programId = '619c22f581310f4e5e3fead3';

export const defaultOptions: RecursivePartial<Options> = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },
    logLevel: 'error',
    useFingerprinting: true,
    messagesWithLocale: {
        'en-US': messagesEN,
        sv: messagesSV,
    },
    marketConsent: {
        enabled: true,
        required: true,
    },
};
